export const SESSION_REFRESH_POLICY = {
  // Session timeout value will never be less than 60 minutes. Also this value should never be more than 55 mins, to allow a buffer.
  refreshCheckIntervalMs: 55 * 60 * 1000
} as const;
